import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { closeApproval } from 'store/messages/actions';

import ModalAccept from './modals/ModalAccept';

const ApprovalMessage = (): JSX.Element | null => {
  const dispatch = useDispatch();
  const approvals = useSelector((state: any) => state.messages.approvals);

  if (approvals.length === 0) {
    return null;
  }

  const triggerCloseApproval = (showing: boolean) => {
    if (!showing) {
      dispatch(closeApproval());
    }
  };

  return (
    <ModalAccept
      header=""
      onApproveCallback={approvals[0].callback}
      showing
      setShowing={triggerCloseApproval}
      text={approvals[0].message}
    />
  );
};

export default ApprovalMessage;
